var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('x-header'),_c('el-container',{staticClass:"main-wrapper"},[_c('x-aside'),_c('el-container',{staticClass:"main-content"},[_c('el-main',[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('router-view')],1)],1)],1)],1),_c('messageAlert')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }